/**  Статус запроса */
export enum RequestsStates {
  /** Не указано */
  None = 0,

  /** Исполняется */
  Executing = 1,

  /** Исполнено */
  Executed = 2,

  /** Отказано */
  Denied = 3,

  /** Подготовка */
  Preparing = 4,

  /** Подготовлен */
  Prepared = 5,

  /** Ошибка подготовки */
  PrepareError = 6,

  /** Ошибка исполнения */
  ExecuteError = 7
}
